import {
  identifyVisitor,
  subscribeToList,
  trackProductSavedEvent,
} from '@/components/integrations/Klaviyo/Actions';

// This file is the only place that knows where a captured email goes. The
// footer SubscribeForm and the PDP Save for Later call through here and stay
// unaware of the destination.
//
// BL-395: Klaviyo replaced Zaius/ODP as the only destination (Richard on the
// ticket, 25 Sep). The Save for Later list and event are the ones Uma signed
// off on 11 Aug.

export const subscribeToNewsletter = async (email) => {
  const result = await subscribeToList(email, 'newsletter');
  if (result?.success) identifyVisitor(email);
  return result;
};

export async function saveForLater(email, productContext = {}) {
  const listResult = await subscribeToList(email, 'save_for_later');
  if (listResult?.success) identifyVisitor(email);

  // Fire and forget: the email is on the list either way, and a failed event
  // should not turn a successful save into an error.
  if (listResult?.success) {
    trackProductSavedEvent(email, productContext).catch(() => {});
  }

  return listResult;
}
